export enum Permission {
  /**
   * BEGIN NAVBAR MENU
   */
  VIEW_NAVBAR_DASHBOARD_MENU = "view-navbar-dashboard-menu",
  VIEW_NAVBAR_PROJECTS_MENU = "view-navbar-projects-menu",
  VIEW_NAVBAR_CONTRACTS_MENU = "view-navbar-contracts-menu",
  VIEW_NAVBAR_RESOURCES_MENU = "view-navbar-resources-menu",
  VIEW_NAVBAR_REPORTS_MENU = "view-navbar-reports-menu",
  VIEW_NAVBAR_SETTINGS_MENU = "view-navbar-settings-menu",
  /**
   * END NAVBAR Menu
   */
  /**
   * BEGIN Dashboard
   */
  VIEW_DASHBOARD="view-dashboard",
  VIEW_DASHBOARD_CHART="view-dashboard-chart",
  VIEW_DASHBOARD_WEEKLY_ALLOCATIONS="view-dashboard-weekly-allocations",
  VIEW_DASHBOARD_FILTERS="view-dashboard-filters",
  APPLY_DASHBOARD_SDL_FILTERS="apply-dashboard-sdl-filters",
  APPLY_DASHBOARD_CUSTOMER_FILTERS="apply-dashboard-customer-filters",
  APPLY_DASHBOARD_PROJECT_FILTERS="apply-dashboard-project-filters",
  VIEW_DASHBOARD_STAFFING_NEEDS="view-dashboard-staffing-needs",
  EXPORT_DASHBOARD_STAFFING_NEEDS="export-dashboard-staffing-needs",
  EXPORT_DASHBOARD_ALLOCATION_REPORTS="export-dashboard-allocation-reports",
  VIEW_DASHBOARD_SEARCHBAR="view-dashboard-searchbar",
  VIEW_DASHBOARD_AVAILABILITY_REPORT="view-dashboard-availability-report",
  EXPORT_DASHBOARD_AVAILABILITY_REPORT="export-dashboard-availability-report",
  APPLY_DASHBOARD_BUSINESS_UNIT_FILTERS = "apply-dashboard-business-unit-filter",
  /**
   * END Dashboard
   */
  /**
   * BEGIN Projects
   */
  VIEW_PROJECTS="view-projects",
  VIEW_PARTIAL_PROJECTS="view-partial-projects",
  VIEW_PROJECT_DETAILS="view-project-details",
  VIEW_PROJECT_ALLOCATIONS="view-project-allocations",
  VIEW_EMPLOYEE_ALLOCATIONS="view-employee-allocations",
  VIEW_PROJECT_CONTRACTS="view-project-contracts",
  VIEW_PROJECT_ASSIGNED_RESOURCES="view-project-assigned-resources",
  VIEW_PROJECT_HEALTH="view-project-health",
  CREATE_PROJECT="create-project",
  CREATE_PROJECT_RESOURCE="create-project-resource",
  REQUEST_NEW_PROJECT_RESOURCE="request-new-project-resource",
  EDIT_PROJECT="edit-project",
  EDIT_PROJECT_ALLOCATIONS="edit-project-allocations",
  DELETE_PROJECT="delete-project",
  DELETE_PROJECT_ALLOCATIONS="delete-project-allocations",
  IMPORT_PROJECTS="import-projects",
  EXPORT_PROJECTS="export-projects",
  EXPORT_PROJECT_AS_PDF="export-project-as-pdf",
  EXPORT_PROJECT_AS_EXCEL="export-project-as-excel",
  EXPORT_PROJECT_AS_CSV="export-project-as-csv",
  VIEW_PROJECT_FILTERS="view-project-filters",
  APPLY_PROJECT_FILTER_BY_SDL="apply-project-filter-by-sdl",
  APPLY_PROJECT_FILTER_BY_PROJECT="apply-project-filter-by-project",
  APPLY_PROJECT_FILTER_BY_STATUS="apply-project-filter-by-status",
  /**
   * END Projects
   */
  /**
   * BEGIN resources
   */
  VIEW_RESOURCES="view-resources",
  VIEW_RESOURCE_DETAILS="view-resource-details",
  CREATE_RESOURCES="create-resources",
  ACTIVATE_RESOURCES="activate-resources",
  DEACTIVATE_RESOURCES="deactivate-resources",
  EDIT_RESOURCES="edit-resources",
  DELETE_RESOURCES="delete-resources",
  IMPORT_RESOURCES="import-resources",
  ASSIGN_PROJECT_RESOURCE="assign-project-resource",
  EXPORT_RESOURCES="export-resources",
  APPLY_RESOURCES_FILTERS="apply-resource-filters",
  APPLY_RESOURCE_FILTER_BY_SDL="apply-resource-filter-by-sdl",
  APPLY_RESOURCE_FILTER_BY_PROJECT="apply-resource-filter-by-project",
  APPLY_RESOURCE_FILTER_BY_DATE_WEEK="apply-resource-filter-by-date-week",
  APPLY_RESOURCE_FILTER_BY_SEARCH="apply-resource-filter-by-search",
  /**
   * END resources
   */
  /**
   * BEGIN attributes
   */
  VIEW_BILL_TYPES="view-bill-types",
  VIEW_RESOURCE_TYPES="view-resource-types",
  CREATE_RESOURCE_TYPES="create-resource-types",
  EDIT_RESOURCE_TYPES="edit-resource-types",
  DELETE_RESOURCE_TYPES="delete-resource-types",
  DELETE_PROJECT_RESOURCE_TYPES="delete-project-resource-types",
  /**
   * END attributes
   */
  /**
   * BEGIN customers
   */
  VIEW_CUSTOMERS="view-customers",
  CREATE_CUSTOMERS="create-customers",
  EDIT_CUSTOMERS="edit-customers",
  DELETE_CUSTOMERS="delete-customers",
  /**
   * END customers
   */
  /**
   * BEGIN Users
   */
  VIEW_SDLS="view-sdls",
  /**
   * END Users
   */
  /**
   * BEGIN Reports
   */
  VIEW_REPORTS="view-reports",
  VIEW_REPORTS_INTACCT_POWERBI="view-reports-intacct-powerbi",
  VIEW_REPORTS_SDL_PROJECTS="view-reports-sdl-projects",
  VIEW_REPORTS_CUSTOMER_TRACKER="view-reports-customer-tracker",
  EXPORT_SDL_PROJECT_REPORTS="export-sdl-project-reports",
  /**
   * END Reports
   */
  /**
   * BEGIN Settings
   */
  VIEW_SETTINGS="view-settings",
  VIEW_SETTINGS_USERS="view-settings-users",
  VIEW_SETTINGS_ROLES="view-settings-roles",
  VIEW_SETTINGS_PERMISSIONS="view-settings-permissions",
  VIEW_SETTINGS_ATTRIBUTES="view-settings-attributes",
  VIEW_SETTINGS_CUSTOMERS="view-settings-customers",
  VIEW_SETTINGS_SDLS="view-settings-sdls",
  VIEW_SETTINGS_TEMPLATES="view-settings-templates",
  VIEW_SETTINGS_IMPORTS="view-settings-imports",
  VIEW_SETTINGS_ACTIVITY_LOG="view-settings-activity-log",
  VIEW_SETTINGS_EMAIL_CONFIGURATIONS="view-settings-email-configurations-menu",
  /**
   * END Settings
   */
  /**
   * BEGIN Roles
   */
  CREATE_ROLES="create-roles",
  EDIT_ROLES="edit-roles",
  DELETE_ROLES="delete-roles",
  ASSIGN_PERMISSION_TO_ROLE="assign-permission-to-role",
  REMOVE_PERMISSION_FROM_ROLE="remove-permission-from-role",
  /**
   * END Roles
   */
  /**
   * BEGIN Permissions
   */
  CREATE_PERMISSIONS="create-permissions",
  EDIT_PERMISSIONS="edit-permissions",
  DELETE_PERMISSIONS="delete-permissions",
  /**
   * END Permissions
   */
  /**
   * BEGIN users
   */
  INVITE_USER = "invite-user",
  EDIT_USER = "edit-user",
  DELETE_USER = "delete-user",
  ACTIVATE_USER = "activate-user",
  DEACTIVATE_USER = "deactivate-user",
  /**
   * END users
   */
  /**
   * BEGIN Intacct
   */

  IMPORT_INTACCT_TIMESHEETS = "import-intacct-timesheets",
  VIEW_INTACCT_EMPLOYEES = "view-intacct-employees",
  /**
   * END Intacct
   */
  MANAGE_TEMPLATES = "manage-templates",
  VIEW_TEMPLATES = "view-templates",
  UPLOAD_TEMPLATES = "upload-templates",
  DOWNLOAD_TEMPLATES = "download-templates",
  DELETE_TEMPLATES = "delete-templates",
  /**
   * BEGIN Email Configurations
   */
  VIEW_EMAIL_CONFIGURATIONS = "view-email-configurations",
  CREATE_EMAIL_CONFIGURATIONS = "create-email-configurations",
  EDIT_EMAIL_CONFIGURATIONS = "edit-email-configurations",
  DELETE_EMAIL_CONFIGURATIONS = "delete-email-configurations",

}
